import React, { FC, useState } from "react";
import Dialog from "../../dialog";
import {
  Container,
  HeadWrapper,
  BodyModal,
  Icon,
} from './styles'
import { icons } from "../../../icons";
import Typography from "../../typography";
import Button from "../../button";
import { useTranslation } from "react-i18next";
import { HeadLine3 } from "../../typography/styled";
import IcSuccess from './icon.svg'
            
type ModalProps = {
  closeModalCancel:() => void;
  closeModal:() => void;
  alertTitle?:any;
  alertSubTitle?:any;
  confirmButtonText?:any;
  cancelButtonText?:any;
  loading?:boolean;
}  

const RequestAccessCluster:FC<ModalProps> = (props) => {
  const {
    closeModal,
    closeModalCancel,
    alertTitle,
    alertSubTitle,
    loading,
    confirmButtonText,
    cancelButtonText,
  } = props
  const [t] = useTranslation()

  return(
    <Container>
      <HeadWrapper>
        {/* <HeadLine3 style={{marginLeft:'10px', marginTop:'10px'}}>
          {alertTitle}
        </HeadLine3> */}
        <div/>
        <Icon onClick={closeModalCancel} src={icons.CloseIcon}/>
      </HeadWrapper>
      <BodyModal>
        <img src={IcSuccess}/>
        <HeadLine3 style={{ marginTop:'14px'}}>
          {t("TITLE_REQUEST_CLUSTER_SUCCESS")}
        </HeadLine3>
        <Typography variant="body">{t("BODY_REQUEST_CLUSTER_SUCCESS")}</Typography>
        <div style={{display:"flex", marginTop:'30px', width:'100%'}}>
          <Button
            variant="stroke"
            size="display"
            customStyles={{ width: '100%', justifyContent:'center' }}
            onClick={closeModalCancel}
            title={t("CONTINUE")}
          />
        </div>
      </BodyModal>
    </Container>
  )
}

export default RequestAccessCluster